import React, { ButtonHTMLAttributes} from 'react';

import { SButton } from '../styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
};

const Button: React.FC<ButtonProps> = ({children, loading, ...rest}) => {
  return (
    <SButton type="button" {...rest}>
        {loading ? 'Aguarde' : children}
    </SButton>
  );
}

export default Button;